import qs from "qs";

import LocalityApi from "../../services/api/Locality";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath, unFlattenObj } from "../../utils";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in locality actions:", err);
}

export const setLocalityList = (payload) => {
  return {
    type: ActionTypes.SET_LOCALITY_LIST,
    payload,
  };
};

export const setCurrentPageLocality = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_LOCALITY,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_LOCALITY_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_LOCALITY,
    payload,
  };
};

export const getLocalityList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
      };

      // remove the "locality." prefix from filters.
      if (Object.keys(filters).length > 0) {
        Object.keys(filters).forEach((key) => {
          const filterKey = key.replace("locality.", "");
          finalPayload[filterKey] = filters[key];
        });
      }

      // channge locality_name to startswith
      if (getPath(finalPayload, "locality_name", undefined)) {
        finalPayload["startswith"] = finalPayload["locality_name"];
        delete finalPayload["locality_name"];
      }

      // change city_id to array
      if (
        getPath(finalPayload, "city_id", undefined) &&
        !Array.isArray(finalPayload["city_id"])
      ) {
        finalPayload["city_id"] = [finalPayload["city_id"]];
      }

      const queryParams = qs.stringify(finalPayload, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await LocalityApi.getLocalityList(queryParams);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setLocalityList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageLocality(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getBulkLocalities = (localityIds) => async (dispatch) => {
  try {
    var localities = [];
    dispatch(setLoader(true));
    for (const id of localityIds) {
      let finalPayload = {
        id: id,
      };
      let response = await LocalityApi.getLocality(finalPayload);
      if (response) {
        localities = [...localities, getPath(response, "locality", {})];
      }
    }
    dispatch(setLoader(false));
    return localities;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createLocality = (data) => async (dispatch) => {
  try {
    let finalPayload = unFlattenObj(data);
    dispatch(setLoader(true));
    let response = await LocalityApi.createLocality(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
      dispatch(resetState({ state: "activeLocality" }));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateLocality = (id, data) => async (dispatch) => {
  try {
    const finalPayload = unFlattenObj(data);
    dispatch(setLoader(true));
    const response = await LocalityApi.updateLocality(id, finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
      dispatch(resetState({ state: "activeLocality" }));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const setActiveLocality = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_LOCALITY,
    payload,
  };
};

export const getLocality = (id) => async (dispatch) => {
  try {
    let finalPayload = {
      id: id,
    };
    dispatch(setLoader(true));
    let response = await LocalityApi.getLocality(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveLocality(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(setStatus({ type: "error", message: ErrorMsgs.GENERAL_ERROR_1 }));
    handleError(err);
  }
};
